/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';
import { WelcomeCard } from '../../experiments/Welcome/components/WelcomeCard';



export const WelcomeView: React.FC = () => {

  return (
<>
    <WelcomeCard />
</>
  );
};
